import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import HeaderWithoutLogin from "../components/HeaderWithoutLogin";
import styled from "styled-components";
import Card from "../components/Card/Card";
import CustomButton from "../components/CustomButton/CustomButton";
import TermsofServicesContent from "../components/TermsofServicesContent/TermsofServicesContent";
import { setIsUserAcceptedTerms } from "../redux/actions";
import { useEffect } from "react";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .formContainer {
    max-width: 800px;
    width: 100%;
    margin-top: 3%;
  }

  .buttonContainer {
    width: 100%;
    margin-right: 3em;
    text-align: right;
  }
`;

const TermsofServices = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { userAccountDetails } = useSelector((state) => state.user);

  const hanldeAcceptClick = () => {
    dispatch(setIsUserAcceptedTerms());
    history.push("/advisor-agreement");
  };

  useEffect(() => {
    if (userAccountDetails.userType === "Advisor")
      history.push(`/advisor-portal-landing`);
  }, [userAccountDetails]);
  return (
    <>
      <HeaderWithoutLogin
        isHomeClickable={false}
        isLogOutButtonVisible={true}
      />
      <BodyWrapper>
        <div className="formContainer">
          <Card>{<TermsofServicesContent />}</Card>
        </div>
        <div
          className="buttonContainer"
          style={{ width: "100%", maxWidth: "800px", textAlign: "right" }}
        >
          <CustomButton text="Accept" onClick={hanldeAcceptClick} />
        </div>
      </BodyWrapper>
    </>
  );
};

export default TermsofServices;
